<!--
 * @Description: ''
 * @Author: yangruonan(yangruonan@hztianque.com)
 * @Date: 2021-04-28 11:06:06
 * @LastEditTime: 2021-05-08 17:31:44
-->
<template>
  <div class="hotel-mask">
    <Modal
      v-model="showModel"
      :mask-closable="false"
      title="修改酒店"
      @on-cancel="cancelModel">
      <Form
        ref="formValidate"
        :model="formValidate"
        :label-width="80"
        :rules="ruleValidate">
        <FormItem label="入住酒店" prop="hotelId">
          <Select v-model="formValidate.hotelId">
            <Option
              v-for="item in hotelList"
              :value="item.id"
              :key="item.id">
              {{item.hotelName}}{{item.hotelType}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="入住时间">
          <DatePicker
            :disabled="disabled"
            type="date"
            placeholder="请选择时间"
            v-model="formValidate.checkTime"></DatePicker>
        </FormItem>
        <FormItem label="离店时间">
          <DatePicker
            :disabled="disabled"
            type="date"
            placeholder="请选择时间"
            v-model="formValidate.departureTime"></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelModel">取消</Button>
        <Button type="primary" :loading="loading" @click="asyncSaveOK">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    formValidates: {
      type: Object,
      default: () => ({}),
    },
    hotelList: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      showModel: this.show,
      ruleValidate: {
        hotelId: [
          { required: true, message: '请选择入住酒店' },
        ],
      },
      formValidate: {},
      loading: false,
      disabled: false,
    }
  },
  watch: {
    show(val) {
      this.showModel = val
    },
    formValidates: {
      deep: true,
      handler(val) {
        this.formValidate = val
      },
    },
    formValidate: {
      deep: true,
      handler(val) {
        if (val.hotelId === 0) {
          this.disabled = true
          this.formValidate.checkTime = null
          this.formValidate.departureTime = null
        } else {
          this.disabled = false
        }
      },
    },
  },
  methods: {
    // 关闭
    cancelModel() {
      this.showModel = false
      this.$refs['formValidate'].resetFields()
      this.$emit('showModel', false)
    },
    // 确定
    async asyncSaveOK() {
      let dataObj = {}
      this.hotelList.map(res => {
        if (res.id === this.formValidate.hotelId) {
          dataObj = {
            id: this.formValidate.id,
            hotelId: this.formValidate.hotelId,
            hotelName: `${res.hotelName}${res.hotelType}`,
            checkTime: this.formValidate.checkTime ? this.$moment(this.formValidate.checkTime).format('YYYY-MM-DD') : '',
            departureTime: this.formValidate.departureTime ? this.$moment(this.formValidate.departureTime).format('YYYY-MM-DD') : '',
          }
        }
        return dataObj
      })
      if (dataObj.hotelId !== 0 && !dataObj.hotelId) {
        this.$Message.error('请选择入住酒店!')
        return
      }
      const start = new Date(this.formValidate.checkTime).getTime()
      const end = new Date(this.formValidate.departureTime).getTime()
      if (start && end && start > end) {
        this.$Message.error('离店时间不能早于入住时间')
        return
      }
      this.loading = true
      const { code } = await this.updateSignUpHotel(dataObj)
      if (code === '0') {
        this.cancelModel()
        this.$Message.success('修改成功')
        this.loading = false
      }
    },
    ...mapActions({
      updateSignUpHotel: 'jurisprudenceDaily/reportManagement/updateSignUpHotel',
    }),
  },
}
</script>
<style lang="scss" scoped>
.promptBox {
  color: #f00;
  padding-left: 15px;
}
</style>
